module.exports = __webpack_public_path__ + "static/media/publicar.1572e7e0.png";